module.exports = __webpack_public_path__ + "media/images/logos/University-of-Cambridge-095882cd1b112dc8be236e24e62b4a9a.svg";